export enum NavigationStateKeys {
  Message = 'message',
  RedirectionPath = 'redirectionPath',
}
